<template>
  <div class="page-device" :style="{ height: pageHeight + 'px' }">
    <div class="real-time">
      <div class="option-box">
        <el-select v-model="tower" filterable placeholder="选择楼" @change="towerChange">
          <el-option v-for="item in towers" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="floor" placeholder="选择层" @change="floorChange">
          <el-option v-for="item in floors" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="room" placeholder="选择房" @change="roomChange">
          <el-option v-for="item in rooms" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="companyTag" placeholder="选择公司" @change="companyChange">
          <el-option v-for="item in companys" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="status" placeholder="选择状态" @change="statusChange">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input style="max-width: 120px; margin-right: 20px" placeholder="雷达SN" v-model="searchSn"></el-input>
        <el-button class="option-btn" @click="reset">重置</el-button>
        <el-button class="option-btn" @click="filterDevice">筛选</el-button>
        <el-button class="option-btn" @click="addDelDevice">添加设备</el-button>
        <el-button class="option-btn" @click="getTemplate">模板下载</el-button>
        <el-upload class="upload" :headers="headers" action="/plat/sstk-plat/api/device/import-device-info"
          name="importFile" :show-file-list="false" :on-success="uploadFileSuccess" :on-error="uploadFileFail"
          ref="uploadFile" accept=".xls, .xlsx" style="margin: 0 10px">
          <el-button class="option-btn" slot="trigger">批量导入</el-button>
        </el-upload>
        <el-button class="option-btn" style="margin-right: 10px" @click="exportAllList">列表导出</el-button>
        <el-popconfirm title="是否删除？" @confirm="batchDel">
          <el-button type="danger" slot="reference" style="border-radius: 8px">批量删除</el-button>
        </el-popconfirm>

      </div>
      <div class="monitor-info-title">
        <div>
          <i class="check-box" :class="isAllCheck == 0
            ? ''
            : isAllCheck == 1
              ? 'check-half-box'
              : isAllCheck == 2
                ? 'check-all-box'
                : ''
            " @click="allCheck"></i>
        </div>
        <div></div>
        <div>雷达名称</div>
        <div>所属公司</div>
        <div>雷达SN码</div>
        <div>雷达IP</div>
        <div>雷达端口</div>
        <div>监控时间段</div>
        <div>房间</div>
        <div>安装位置</div>
        <div>状态</div>
        <div>详情</div>
        <div>操作</div>
      </div>
      <el-scrollbar style="height: 100%">
        <div class="list-box" v-loading="isLoading">
          <div class="monitor-info" :style="{ background: index % 2 == 0 ? '#efefef' : '' }"
            v-for="(item, index) in deviceList" :key="'showDevice' + index">
            <div class="device-list-content-one">
              <i :class="item.isSelect ? 'check-box check-box-select' : 'check-box'
                " @click="selectList(item)"></i>
            </div>
            <div class="device-list-content-one">
              <img :src="item.radarType == '1001' ? radarLifeImg : radarDownImg" />
            </div>
            <div>{{ item.name }}</div>
            <div>{{ item.companyName }}</div>
            <div>{{ item.sn }}</div>
            <div>{{ item.ip }}</div>
            <div>{{ item.port }}</div>
            <div>{{ item.startTime }}~{{ item.endTime }}</div>
            <div>{{ item.roomName }}</div>
            <div>{{ item.bedName }}</div>
            <div>{{ item.status == 1 ? '在线' : '离线' }}</div>
            <div style="color: #1d63fd; cursor: pointer;" @click="handleSetRadar(item)">详情</div>
            <el-popconfirm title="是否删除？" @confirm="deleteDevice(item)">
              <div class="radar-set-text" slot="reference">删除</div>
            </el-popconfirm>
            

          </div>
        </div>
      </el-scrollbar>
      <el-pagination :page-size="pageSize" :total="deviceTotal" @current-change="pageChange"></el-pagination>
    </div>

    <el-drawer :title="title" :visible.sync="drawer" direction="rtl" size="20%" :append-to-body="true">
      <div class="drawer">
        <div class="drawer-content">
          <div style="text-align: center; margin-bottom: 20px; color: #606266">
            {{ deviceTitle }}
          </div>
          <el-form :model="radarForm">
            <el-form-item label="雷达位置" label-width="100px">
              <el-select v-model="radarForm.bed" placeholder="选择位置">
                <el-option v-for="item in beds" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="雷达类型" label-width="100px">
              <el-select v-model="radarForm.selectRadar" placeholder="选择雷达类型">
                <el-option v-for="item in radarTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属环境" label-width="100px">
              <el-select v-model="radarForm.eseType" placeholder="选择环境">
                <el-option v-for="item in eseTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属公司" label-width="100px">
              <el-select v-model="radarForm.companyTag" placeholder="选择公司">
                <el-option v-for="item in companys" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间" label-width="100px">
              <!-- <el-time-picker v-model="radarForm.startTime" placeholder="开始时间" value-format="HH:mm:ss">
              </el-time-picker> -->

              <el-time-select v-model="radarForm.startTime" :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '23:50'
              }" placeholder="开始时间"></el-time-select>
            </el-form-item>

            <el-form-item label="结束时间" label-width="100px">
              <!-- <el-time-picker v-model="radarForm.endTime" placeholder="结束时间" value-format="HH:mm:ss">
              </el-time-picker> -->
              <el-time-select v-model="radarForm.endTime" :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '23:50'
              }" placeholder="结束时间"></el-time-select>
            </el-form-item>
            <el-form-item label="雷达IP" label-width="100px">
              <el-input v-model="radarForm.ip" :disabled="title=='修改雷达'" />
            </el-form-item>
            <el-form-item label="雷达端口" label-width="100px">
              <el-input v-model="radarForm.port" :disabled="title=='修改雷达'" />
            </el-form-item>
            <el-form-item label="雷达SN码" label-width="100px">
              <el-input v-model="radarForm.sn" :disabled="title=='修改雷达'" />
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-footer">
          <el-button @click="drawer = false">取消</el-button>
          <el-button type="primary" :disabled="!radarForm.selectRadar ||
            !radarForm.startTime ||
            !radarForm.endTime ||
            !radarForm.ip ||
            radarForm.port == '' ||
            radarForm.port == undefined ||
            !radarForm.sn ||
            !radarForm.companyTag || 
            radarForm.eseType == '' ||
            radarForm.eseType == undefined
            " @click="handleConfirm">确定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getBuilding,
  getFloor,
  getRoom,
  getBed,
  getDevice,
  queryRadarType,
  addDevice,
  updateDevice,
  delDevice,
} from "../../api/device";
import { getCompany } from '../../api/user'
export default {
  name: "RealTime",
  data() {
    return {
      pageHeight: 0,
      tower: "",
      floor: "",
      room: "",
      bed: "",
      device: "",
      towers: [],
      floors: [],
      rooms: [],
      devices: [],
      allDevices: [],
      deviceList: [],
      beds: [],
      allBeds: [],
      radarTypes: [],
      isBatch: true,

      updateImg: require("../../assets/images/system/deviceUpdate.svg"),
      isMask: false,
      monitorTime: "",
      radarIp: "",
      radarLifeImg: require("../../assets/images/system/radarLife.svg"),
      radarDownImg: require("../../assets/images/system/radarDown.svg"),
      closeImg: require("../../assets/images/system/close.svg"),

      deviceTitle: "",
      selectRadar: "",
      radarTypeList: [],
      eseTypeList: [{
        label: '生产环境',
        value: 1
      }, {
        label: '测试环境',
        value: 2
      }, {
        label: '本地环境',
        value: 3
      }],
      radarIp: "",
      radarPort: "",
      radarSn: "",
      radarSetPort: "",

      updateRadarList: [],
      updateType: "",

      checkedList: [],

      isAddDelRadar: false,
      isLifeRadar: false,
      isDownRadar: false,
      startTime: "",
      endTime: "",

      drawer: false,
      radarForm: {},
      headers: {},
      deviceTotal: 0,
      currPage: 1,
      pageSize: 15,
      isLoading: false,
      isAllCheck: 0,
      searchSn: "",
      companyTag: '',
      companys: [],
      statusList: [{
        label: '在线',
        value: 1
      }, {
        label: '离线',
        value: 2
      }],
      status: '',
      exportList: [],
      title: '添加雷达'
    };
  },
  created() { },
  mounted() {
    this.initPageHeight();

    window.addEventListener("resize", this.initPageHeight, false);

    this.getTowers();
    this.getFloors();
    this.getRooms();
    this.getBeds();
    this.getAllBeds();
    this.getRadarType();
    this.getCompanys();

    let token = localStorage.getItem("healthyToken");
    if (token) {
      this.headers.token = token;
    }
  },
  computed: {},
  methods: {
    initPageHeight() {
      this.pageHeight = window.innerHeight - 80;
    },

    getCompanys() {
      getCompany().then(res => {
        let list = []
        if (res.data.length > 0) {
          res.data.forEach((item) => {
            let obj = {
              value: item.id,
              label: item.company,
            };
            list.push(obj);
          });
        }
        this.companys = list;

        this.getDeviceList();
      })
    },

    // 获取雷达类型
    getRadarType() {
      queryRadarType({
        codeType: "radar_type",
      }).then((res) => {
        this.radarTypes = res.data;
        res.data.forEach((item) => {
          item.label = item.codeName;
          item.value = item.code;
        });
        this.radarTypeList = res.data;
      });
    },

    // 获取楼列表
    getTowers() {
      getBuilding({
        page: 1,
        size: 9999,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            let obj = {
              value: item.id,
              label: item.name,
            };
            list.push(obj);
          });
        }

        this.towers = list;
      });
    },

    // 选择楼
    towerChange(e) {
      this.floor = "";
      this.room = "";
      this.bed = "";
      this.getFloors();
      this.getRooms();
      this.getBeds();
    },

    // 获取层列表
    getFloors() {
      getFloor({
        page: 1,
        size: 9999,
        buildingId: this.tower,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            let obj = {
              value: item.id,
              label: item.name,
            };
            list.push(obj);
          });
        }

        this.floors = list;
      });
    },

    // 选择层
    floorChange(e) {
      this.room = "";
      this.bed = "";
      this.getRooms();
      this.getBeds();
    },

    // 获取房列表
    getRooms() {
      getRoom({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            item.value = item.id;
            item.label = item.name;
            list.push(item);
          });
        }

        this.rooms = list;
      });
    },

    // 选择房
    roomChange(e) {
      this.bed = "";
      this.getBeds();
    },

    // 获取位置列表
    getBeds() {
      getBed({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
        roomId: this.room,
      }).then((res) => {
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            item.value = item.id;
            item.label = item.name;
          });
          this.beds = res.data.items;
        }
      });
    },

    // 选择页码
    pageChange(e) {
      this.currPage = e;
      this.getDeviceList();
    },

    // 获取所有位置
    getAllBeds() {
      getBed({
        page: 1,
        size: 9999,
      }).then((res) => {
        this.allBeds = res.data.items;

        this.getCompanys()
      });
    },

    companyChange() {
      // this.getDeviceList();
    },

    statusChange() {
      // this.getDeviceList();
    },

    // 获取设备列表
    getDeviceList() {
      let obj = {
        page: this.currPage,
        size: this.pageSize,
        id: this.$store.getters.user.id,
        sn: this.searchSn,
        // radarType: '1001'
      };
      if (this.tower) {
        obj.buildingId = this.tower;
      }
      if (this.floor) {
        obj.floorId = this.floor;
      }
      if (this.room) {
        obj.roomId = this.room;
      }
      if (this.companyTag) {
        obj.companyTag = this.companyTag
      }
      if (this.status) {
        obj.status = this.status;
      }
      this.isLoading = true;
      this.isAllCheck = 0;
      getDevice(obj)
        .then((res) => {
          this.isLoading = false;
          this.deviceTotal = res.data.total;
          if (res.data.records.length > 0) {
            res.data.records.forEach((item) => {
              item.label = item.name;
              item.value = item.id;
              item.isSelect = false;
              if (item.radarType == "1001") {
                item.typeText = "生命体征检测雷达";
              } else if (item.radarType == "1002") {
                item.typeText = "跌倒检测雷达";
              }

              if (this.companys.length > 0) {
                this.companys.forEach(itm => {
                  if (item.companyTag == itm.value) {
                    item.companyName = itm.label;
                  }
                })
              }
            });
            this.deviceList = res.data.records;

            this.deviceList.forEach((item) => {
              this.allBeds.forEach((itm) => {
                if (item.bedId == itm.id) {
                  item.roomName = itm.roomName;
                  item.roomId = itm.roomId;
                  item.bedName = itm.name;
                }
              });
            });
          } else {
            this.deviceList = [];
          }
        })
        .catch(() => {
          this.deviceList = [];
          this.isLoading = false;
        });
    },

    exportAllList() {
      let obj = {
        page: 1,
        size: 99999,
        id: this.$store.getters.user.id,
        sn: this.searchSn,
      };
      if (this.tower) {
        obj.buildingId = this.tower;
      }
      if (this.floor) {
        obj.floorId = this.floor;
      }
      if (this.room) {
        obj.roomId = this.room;
      }
      if (this.companyTag) {
        obj.companyTag = this.companyTag
      }
      if (this.status) {
        obj.status = this.status;
      }
      getDevice(obj)
        .then((res) => {
          if (res.data.records.length > 0) {
            res.data.records.forEach((item) => {
              item.label = item.name;
              item.value = item.id;
              item.isSelect = false;
              if (item.radarType == "1001") {
                item.typeText = "生命体征检测雷达";
              } else if (item.radarType == "1002") {
                item.typeText = "跌倒检测雷达";
              }

              if (item.status == 1) {
                item.statusInfo = '在线'
              } else {
                item.statusInfo = '离线'
              }

              item.monitorTime = `${item.startTime}-${item.endTime}`

              if (this.companys.length > 0) {
                this.companys.forEach(itm => {
                  if (item.companyTag == itm.value) {
                    item.companyName = itm.label;
                  }
                })
              }
            });
            this.exportList = res.data.records;
          } else {
            this.exportList = [];
          }

          this.exportListToExcel();
        })
    },

    // 重置
    reset() {
      this.tower = "";
      this.floor = "";
      this.room = "";
      this.searchSn = "";
      this.companyTag = ""
      this.status = ""

      this.getBeds();

      this.currPage = 1;
      this.getDeviceList();
    },

    // 筛选
    filterDevice() {
      this.currPage = 1;
      this.getDeviceList();
    },

    // 获取模板
    getTemplate() {
      // window.location.href = "/plat/sstk-plat/api/device/file-upload";
      window.location.href = "/static/雷达导入模板.xlsx";
    },

    // 选择列表
    selectList(data) {
      data.isSelect = !data.isSelect;

      let list = [];
      this.deviceList.forEach((item) => {
        list.push(item.isSelect);
      });

      if (list.indexOf(true) == -1) {
        this.isAllCheck = 0;
      } else if (list.indexOf(false) == -1) {
        this.isAllCheck = 2;
      } else {
        this.isAllCheck = 1;
      }
    },

    handleSetRadar(data){
      this.drawer = true;
      let obj = JSON.parse(JSON.stringify(data));
      obj.selectRadar = obj.radarType.toString();
      obj.bed = obj.bedId
      obj.companyTag = obj.companyTag.toString()
      this.radarForm = obj
      this.title = '修改雷达'
    },

    handleConfirm(){
      if(this.title == '添加雷达'){
        this.addRadar()
      }else{
        this.updateRadar()
      }
    },

    // 添加雷达
    addRadar() {
      let name = "";
      this.radarTypeList.forEach((item) => {
        if (item.code == this.radarForm.selectRadar) {
          name = item.codeName;
        }
      });
      addDevice({
        ip: this.radarForm.ip,
        port: this.radarForm.port,
        setPort: this.radarSetPort,
        sn: this.radarForm.sn,
        name: name,
        companyTag: this.radarForm.companyTag,
        bedId: this.radarForm.bed,
        radarType: this.radarForm.selectRadar,
        startTime: this.radarForm.startTime + ':00',
        endTime: this.radarForm.endTime + ':00',
        eseType: this.radarForm.eseType
      }).then((res) => {
        this.drawer = false;
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.getDeviceList();
      });
    },

    // 更新雷达
    updateRadar(){
      if (this.radarForm.startTime.length == 5) {
        this.radarForm.startTime = this.radarForm.startTime + ':00';
      }

      if (this.radarForm.endTime.length == 5) {
        this.radarForm.endTime = this.radarForm.endTime + ':00'
      }

      this.radarForm.bedId = this.radarForm.bed
      updateDevice(this.radarForm).then(res => {
        this.drawer = false;
        this.$message({
          type: "success",
          message: "修改成功",
        });
        this.getDeviceList();
      })
    },

    // 删除雷达
    removeRadar() {
      let list = [];
      if (this.allDevices.length > 0) {
        this.allDevices.forEach((item) => {
          if (item.delSelect) {
            list.push(item.id);
          }
        });
      }
      delDevice({
        ids: list,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.getDeviceList();
      });
    },

    // 上传文件成功
    uploadFileSuccess(e) {
      this.$message(e.data);
      this.getDeviceList();
    },

    // 上传文件失败
    uploadFileFail(e) {
      this.$message("上传失败");
    },

    // 添加删除雷达
    addDelDevice() {
      // if (this.room == "") {
      //   this.$message("请先选择房间");
      // } else {
      this.rooms.forEach((item) => {
        if (item.id == this.room) {
          this.deviceTitle = `${item.buildingName}-${item.floorName}-${item.name}`;
        }
      });
      this.title = '添加雷达'
      this.radarForm = {};
      this.drawer = true;
      // }
    },

    // 全选
    allCheck() {
      if (this.deviceList.length > 0) {
        let isExist = false;
        this.deviceList.forEach((item) => {
          if (!item.isSelect) {
            isExist = true;
          }
        });

        this.deviceList.forEach((item) => {
          if (isExist) {
            item.isSelect = true;
            this.isAllCheck = 2;
          } else {
            item.isSelect = false;
            this.isAllCheck = 0;
          }
        });
      }
    },

    // 删除设备
    deleteDevice(data) {
      this.delRadar([data.id]);
    },

    // 批量删除
    batchDel() {
      if (this.deviceList.length > 0) {
        let list = [];
        this.deviceList.forEach((item) => {
          if (item.isSelect) {
            list.push(item.id);
          }
        });

        this.delRadar(list);
        this.currPage = 1;
      }
    },

    // 删除雷达
    delRadar(data) {
      delDevice({
        ids: data,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.getDeviceList();
      });
    },

    // 导出表格
    exportListToExcel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../vendor/Export2Excel");
        const tHeader = [
          "雷达名称",
          "所属公司",
          "雷达SN码",
          "雷达IP",
          "监控时间段",
          "状态"
        ];
        const filterVal = [
          "name",
          "companyName",
          "sn",
          "ip",
          "monitorTime",
          "statusInfo",
        ];
        const list = this.exportList;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "设备列表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initPageHeight, false);
    if (this.isMask) {
      this.back();
    }
    if (this.webSocket) {
      this.webSocket.close();
    }
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-device {
  width: 100%;
  height: 100%;
  padding: 20px;
  // padding: 70px 60px 60px 60px;
  // padding: 3vw 5.5vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .real-time {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 40px 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .option-box {
      display: flex;
      justify-content: center;

      .option-btn {
        width: 100px;
        height: 40px;
        font-size: 14px;
        color: #fff;
        background: #1d63fd;
        border-radius: 8px;
        border: none;
        // margin-right: 38px;
      }

      // .option-btn:nth-child(4) {
      //   width: 150px;
      //   margin-right: 0;
      // }
      // .option-btn:last-child {
      //   width: 150px;
      //   margin-right: 0;
      // }
    }

    .monitor-info-title {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #8c8c8c;
      margin-top: 40px;

      div {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      div:nth-child(1),
      div:nth-child(2),
      div:last-child {
        max-width: 100px;
      }

      .check-box {
        width: 25px;
        height: 25px;
        box-sizing: border-box;
        border: 1px solid #c9d5ef;
        background: #fff;
        display: block;
      }

      .check-all-box {
        background: #1d63fd;
      }

      .check-half-box {
        border: 5px solid #c9d5ef;
        // border: 5px solid #fff;
        background: #1d63fd;
      }
    }

    .list-box {
      flex: 1;

      .monitor-info {
        height: 60px;
        display: flex;
        align-items: center;
        font-size: 15px;

        img {
          width: 30px;
          height: 30px;
        }

        div {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 100px;
        }

        div:nth-child(1),
        div:nth-child(2),
        div:last-child {
          max-width: 100px;
        }

        .check-box {
          width: 25px;
          height: 25px;
          box-sizing: border-box;
          border: 1px solid #c9d5ef;
          background: #fff;
          display: block;
        }

        .check-box-select {
          background: #1d63fd;
        }

        .radar-set-text {
          color: #f56c6c;
          cursor: pointer;
        }
      }
    }
  }

  .page-num-box {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;

    .page-num-list {
      height: 60px;
      display: flex;
      align-items: center;

      .page-num {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #26415f;
      }

      .page-num-active {
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #c9d5ef;
        border-radius: 8px;
      }
    }
  }
}

.drawer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .drawer-content {
    padding-right: 12px;
    flex: 1;
  }

  .drawer-footer {
    padding: 0 12px;
    height: 60px;
    box-sizing: border-box;
    border-top: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
<style>
.page-device .real-time .el-select {
  width: 150px;
  margin-right: 38px;
}

.el-input__inner {
  border-color: 1px solid#c9d5e7;
  border-radius: 8px;
}

.time-select .el-select {
  width: 100px;
  margin: 0 auto;
}

.time-select .el-input__inner {
  font-size: 13px;
}

.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/system/deviceList.vue